export const DEV_CONSOLE_API = {
  auth: {
    base: '/auth',
    login: '/login',
    register: '/register'
  },
  adapters: {
    base: '/adapters',
    lookups: '/lookup',
    single: '/:id'
  }
};
